/**
 * CinematicFade — lighter-weight opening: a black overlay fades up,
 * holds a beat, then fades away to reveal the cinematic intro
 * underneath. Cheaper than the theatre curtain on lower-end devices.
 *
 * Also serves as the no-op fallback when `code === 'none'`: it just
 * renders `<></>` once `active` flips to false.
 */
import type { OpeningProps } from './OpeningRegistry';

export function CinematicFade({ active }: OpeningProps) {
  if (!active) return null;
  return (
    <div
      className="pointer-events-none absolute inset-0 z-30 bg-black"
      style={{
        animation:
          'cinematic-fade-in 0.35s ease-out, cinematic-fade-out 0.5s ease-out 4.9s forwards',
      }}
      aria-hidden="true"
    />
  );
}
